import React from 'react';
//modalPopup
import Modal from 'react-modal';
import 'src/asset/scss/plugin/modalPopup.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트
//comp
import ItemIndex from './ItemIndex';//차량모델선택

export default function VehicleList(props) {
    //cssStyles
    const popupStyles = {
        content: {
            width: "33.125rem",
            height: "100%"
        }
    };
    const { isOpen, checkedItem, setCheckedItem, vehicleList } = props;//props
    /* ==================== 팝업오픈핸들러 ==================== */
    const onCloseHandler = () => {
        props.onDismiss('add', false);
    }
    /* ==================== 팝업오픈핸들러 ==================== */
    const onSubmitHandler = (newItems) => {
        setCheckedItem(newItems);
        props.onDismiss('add', false);
    }
    class BoardUpdate extends React.Component {
        state = { isDisabled:true, checkedItems:[] };
        handleChange = (e, value) => { 
            //this.setState({  ...this.state, index:value }); 
            this.setState({ isDisabled:true }); 
        };
        onValidItem = (value) => {
            this.setState({ isDisabled:value.length > 0 ? false : true, checkedItems:value });
            // if(this.state.isDisabled != value) {
            //     this.setState({...this.state, isDisabled:value });
            // }
        };
        render() { 
            const { isDisabled, checkedItems } = this.state;

        return ( 
            <Modal isOpen={isOpen} onRequestClose={null} style={popupStyles} ariaHideApp={false}>
                <Element tag={`div`} className="popupContainer">
                    <Element tag={`div`} className="popupHeader"><Element tag={`h1`}>사용 차량 추가</Element></Element>
                    <Element tag={`div`} className="popupContainer">
                        <Element tag={`div`} className="popupFormArea">
                            <ItemIndex list={vehicleList} checkedItem={checkedItem} onValid={this.onValidItem} />
                        </Element>
                    </Element>
                    <Element tag={`div`} className="popupFooter">
                        <Element tag={`div`} className="btnArea">
                            <Button anyprop={(e) => onCloseHandler()} class="secondaryButton" label={"취소"} ></Button>
                            <Button anyprop={(e) => onSubmitHandler(checkedItems)} disabled={isDisabled} class="submitButton" label={"등록하기"} ></Button>
                        </Element>
                    </Element>
                </Element>
            </Modal>
        )}
    } return ( <BoardUpdate /> )
}